export default "__VITE_ASSET__dxs7Bpw5__"